import * as Yup from 'yup';
import { digitsEnToFa } from 'persian-tools2';
// validation
export const validationSchemaAgent = Yup.object({
  // name
  firstName: Yup.string()
    .trim()
    .min(3, `نام شما کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
    .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
    .matches(/^[\u0600-\u06FF\s]+$/, {
      message: 'لطفا نام خود را فارسی وارد کنید.',
    })
    .nullable(true)
    .required('لطفا نام خود را وارد کنید.'),
  // lastName
  lastName: Yup.string()
    .trim()
    .min(3, `نام خانوادگی شما کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
    .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
    .matches(/^[\u0600-\u06FF\s]+$/, {
      message: 'لطفا نام خانوادگی خود را فارسی وارد کنید.',
    })
    .nullable(true)
    .required('لطفا نام خانوادگی خود را وارد کنید.'),
  // phone
  phoneNumber: Yup.string()
    .trim()
    .min(11, `شماره موبایل شما کمتر از ${digitsEnToFa(11)} رقم میباشد.`)
    .max(11, `شماره موبایل شما بیشتر از ${digitsEnToFa(11)} رقم میباشد.`)
    .matches(/^(09)\d{9}$/i, {
      message: `شماره موبایل باید با ${digitsEnToFa('09')} شروع شود .`,
    })
    .required('لطفا شماره موبایل خود را وارد کنید.'),
  scanCenterName: Yup.string()
    .trim()
    .min(3, `نام مرکز اسکن شما کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
    .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
    .matches(/^[\u0600-\u06FF\s]+$/, {
      message: 'لطفا نام مرگز اسکن خود را فارسی وارد کنید.',
    })
    .nullable(true)
    .required('لطفا نام مرکز اسکن خود را وارد کنید.'),
  // address
  scanCenterAddress: Yup.string()
    .trim()
    .max(250, `شما تنها مجاز به نوشتن ${digitsEnToFa(250)} کارکتر میباشید.`)
    .nullable(true),
  // city 
  cityId: Yup.object()
    .required('لطفا شهر خود را انتخاب کنید.')
  ,
  // province
  provinceId: Yup.object()
    .required('لطفا استان خود را انتخاب کنید.'),
});


export const notCenter_ValidationSchema = Yup.object({
  // name
  firstName: Yup.string()
    .trim()
    .min(3, `نام شما کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
    .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
    .matches(/^[\u0600-\u06FF\s]+$/, {
      message: 'لطفا نام خود را فارسی وارد کنید.',
    })
    .nullable(true)
    .required('لطفا نام خود را وارد کنید.'),
  // lastName
  lastName: Yup.string()
    .trim()
    .min(3, `نام خانوادگی شما کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
    .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
    .matches(/^[\u0600-\u06FF\s]+$/, {
      message: 'لطفا نام خانوادگی خود را فارسی وارد کنید.',
    })
    .nullable(true)
    .required('لطفا نام خانوادگی خود را وارد کنید.'),
  // phone
  phoneNumber: Yup.string()
    .trim()
    .min(11, `شماره موبایل شما کمتر از ${digitsEnToFa(11)} رقم میباشد.`)
    .max(11, `شماره موبایل شما بیشتر از ${digitsEnToFa(11)} رقم میباشد.`)
    .matches(/^(09)\d{9}$/i, {
      message: `شماره موبایل باید با ${digitsEnToFa('09')} شروع شود .`,
    })
    .required('لطفا شماره موبایل خود را وارد کنید.'),
});